function addExtraFields() {
  var pw3Config = JSON.parse(Ecwid.getAppPublicConfig(appClientId));
  var payGateId = pw3Config.payGateId;
  if (pw3Config.testMode === 'true') {
    payGateId = '10011072130';
  }
  var isPaygate = false;
  var payMethod = jQuery('label.ec-radiogroup__item--checked');
  if (payMethod.length > 0) {
    var classes = payMethod[0].className;
    if (classes && classes.includes(appClientId)) {
      isPaygate = true;
    }
  }

  if (isPaygate && pw3Config.allowTokenisation === 'true') {
    // Get customer detail and then process further
    Ecwid.OnSetProfile.add(function (customer) {
      if (!customer) {
        //Customer null if not logged in
        //Vaulting not possible so just exit
        return;
      }
      var customerId = customer ? customer.id : 0;
      //Now make call to get customer vault detail
      var vaultUrl = 'https://checkout.dpo.store/za/e/payvault-request.php';
      var areVaults = false;
      jQuery.get(vaultUrl, { 'customerId': customerId, 'payGateId': payGateId }, null, 'json')
        .done(function (vaults) {
          var cardSelects = [];
          var cardManages = [];
          var confirmOptions = [];
          if (vaults.count > 0) {
            areVaults = true;
            confirmOptions.push('No');
            confirmOptions.push('Yes');
            jQuery.each(vaults.cards, function (key, card) {
              cardSelects.push('Use card ' + card.card_no + ' expiring ' + card.expiry_string);
              cardManages.push('Delete (#' + card.id + ') card ' + card.card_no + ' expiring ' + card.expiry_string);
            });
          }
          cardSelects.push('Use new card and do not save');
          cardSelects.push('Use new card and save');
          ec.order = ec.order || {};
          ec.order.extraFields = ec.order.extraFields || {};
          ec.order.extraFields.cardToken = {
            'title'                 : 'Select tokenisation options ',
            'type'                  : 'select',
            'required'              : true,
            'selectOptions'         : cardSelects,
            'available'             : true,
            'checkoutDisplaySection': 'payment_details',
          };
          ec.order.extraFields.cardManage = {
            'title'                 : 'Manage stored cards',
            'type'                  : 'select',
            'required'              : false,
            'selectOptions'         : cardManages,
            'available'             : areVaults,
            'checkoutDisplaySection': 'payment_details',
            'tip'                   : 'Select card to delete and then confirm by selecting "yes" in the delete confirmation box below'
          };
          ec.order.extraFields.confirmCardDelete = {
            'title'                 : 'Confirm deletion (by selecting yes)',
            'type'                  : 'select',
            'selectOptions'         : confirmOptions,
            'required'              : false,
            'available'             : areVaults,
            'checkoutDisplaySection': 'payment_details',
            'value'                 : '',
          };
          Ecwid.refreshConfig();
        })
        .fail(function (error) {
          // Local JS error handler
        });
    });
  } else {
    ec.order = ec.order || {};
    ec.order.extraFields = ec.order.extraFields || {};
    ec.order.extraFields.cardToken = {
      'title'                 : 'Select tokenisation options ',
      'type'                  : 'select',
      'required'              : false,
      'selectOptions'         : [],
      'available'             : false,
      'checkoutDisplaySection': 'payment_details',
    };
    ec.order.extraFields.cardManage = {
      'title'                 : 'Manage stored cards',
      'type'                  : 'select',
      'required'              : false,
      'selectOptions'         : [],
      'available'             : false,
      'checkoutDisplaySection': 'payment_details',
    };
    ec.order.extraFields.confirmCardDelete = {
      'title'                 : 'Confirm deletion (by typing yes)',
      'type'                  : 'select',
      'selectOptions'         : [],
      'required'              : false,
      'available'             : false,
      'checkoutDisplaySection': 'payment_details',
      'value'                 : '',
    };
    Ecwid.refreshConfig();
  }
}

var deleteCardVault = function (cardId) {
  jQuery.post(vaultUrl, { 'delete': true, 'cardId': cardId }, null, 'json')
    .done(function (response) {
      if (response.count > 0) {
        jQuery('div[class$="section--confirmCardDelete"] input').val('The card was successfully deleted');
      } else {
        jQuery('div[class$="section--confirmCardDelete"] input').val('The card was not deleted');
      }
      setTimeout(function () {
        addExtraFields();
      }, 3000);
    })
    .fail(function (error) {
      addExtraFields();
    });
};

jQuery('body').on('change', 'div[class$="section--confirmCardDelete"] select', function (e) {
  var select = jQuery('div[class$="section--cardManage"] select');

  var selected = select.val();
  if (selected) {
    var match = [];
    var re = /.*#(\d+).*/;
    match = selected.match(re);
    if ($(this).val().toLowerCase() === 'yes') {
      if (match && match.length > 1) {
        deleteCardVault(match[1]);
      }
    }
  }
});

/*
 * Copyright (c) 2019 PayGate (Pty) Ltd
 *
 * Author: App Inlet (Pty) Ltd
 *
 * Released under the MIT License
 */

var appClientId = 'paygate-appinlet';
var vaultUrl = 'https://checkout.dpo.store/za/e/payvault-request.php';

Ecwid.OnAPILoaded.add(function () {
    Ecwid.OnPageLoaded.add(function (page) {
            /**
             * Array of links to icons for accepted payment types
             * @type {*[]}
             */
            var iconsSrcList = [
                'https://djqizrxa6f10j.cloudfront.net/apps/ecwid-api-docs/payment-icons-svg/mastercard.svg',
                'https://djqizrxa6f10j.cloudfront.net/apps/ecwid-api-docs/payment-icons-svg/visa.svg',
            ];

            var ecwidFeatureTogglesInfo = Ecwid.getFeatureToggles();
            if (ecwidFeatureTogglesInfo.newCheckoutPage) {
                //New storefront design
                if (page.type == 'CHECKOUT_PAYMENT_DETAILS') {
                    pw3_ecwidUpdatePaymentData(iconsSrcList, appClientId);
                    addExtraFields();
                    setTimeout(function () {
                        pw3_ecwidUpdatePaymentData(iconsSrcList, appClientId);
                        addExtraFields();
                    }, 500);
                    setTimeout(function () {
                        pw3_ecwidUpdatePaymentData(iconsSrcList, appClientId);
                        addExtraFields();
                    }, 3000);
                }
            } else {
                //Old storefront design
                if (page.type == 'CHECKOUT_PAYMENT_DETAILS') {
                    pw3_ecwidUpdatePaymentDataOld(iconsSrcList);
                    addExtraFields();
                    setTimeout(function () {
                        pw3_ecwidUpdatePaymentDataOld(iconsSrcList);
                        addExtraFields();
                    }, 500);
                    setTimeout(function () {
                        pw3_ecwidUpdatePaymentDataOld(iconsSrcList);
                        addExtraFields();
                    }, 3000);
                }
            }
        }
    );

    //Add handler for paymethod changes
    jQuery('body').on('click', 'label.ec-radiogroup__item', function (e) {
        setTimeout(function () {
            addExtraFields();
        }, 250);
    })
});

/**
 * Append payment method icons to payment method in checkout/payment
 * New checkout format
 * @param iconsSrcList
 * @param appClientIdd
 */
var pw3_ecwidUpdatePaymentData = function (iconsSrcList, appClientIdd) {
    var selector = 'label[class*="' + appClientIdd + '"]';
    var payLabel = document.querySelector(selector);

    if (payLabel) {
        var iconTarget = payLabel.querySelector('div.ec-radiogroup__info');
        var div1 = document.createElement('div');
        div1.setAttribute('class', 'ec-cart__accept ec-cart-accept');
        var div2 = document.createElement('div');
        div2.setAttribute('class', 'ec-cart-accept__icons');
        var div3 = document.createElement('div');
        var div4 = document.createElement('div');

        for (var k in iconsSrcList) {
            var image = document.createElement('img');
            image.setAttribute('class', 'ecwid-PaymentMethodsBlockSvg');
            image.setAttribute('src', iconsSrcList[k]);
            image.setAttribute('width', '54');
            image.setAttribute('height', '34');
            div4.appendChild(image);
        }
        div3.appendChild(div4);
        div2.appendChild(div3);
        div1.appendChild(div2);
        while (iconTarget.hasChildNodes()) {
            iconTarget.removeChild(iconTarget.lastChild);
        }
        iconTarget.appendChild(div1);
    }
};

/**
 * Append payment method icons to payment method in checkout/payment
 * Old checkout format
 * @param iconsSrcList
 * @param appClientIdd
 */
var pw3_ecwidUpdatePaymentDataOld = function (iconsSrcList) {
    // Custom styles for icons for our application

    var customStyleForPaymentIcons = document.createElement('style');
    customStyleForPaymentIcons.innerHTML = '.ecwid-PaymentMethodsBlockSvgCustom { display: inline-block; width: 54px; height: 34px; background-color: #fff !important; border: 1px solid #e2e2e2 !important;}';

    document.querySelector('body').appendChild(customStyleForPaymentIcons);

    var optionsContainers = document.getElementsByClassName(
        'ecwid-Checkout')[0].getElementsByClassName(
        'ecwid-PaymentMethodsBlock-PaymentOption');

    for (var i = 0; i < optionsContainers.length; i++) {
        var radioContainer = optionsContainers[i].getElementsByClassName(
            'gwt-RadioButton')[0];
        var label = radioContainer.getElementsByTagName('label')[0];

// If current payment method title matches the one you need

        if (paymentMethodTitle && label.innerHTML.indexOf(paymentMethodTitle) !==
            -1) {
            var container = getPaymentContainer(label);
            if (
                container
                && container.getElementsByTagName('img').length === 0
            ) {
                for (i = 0; i < iconsSrcList.length; i++) {
                    var image = document.createElement('img');
                    image.setAttribute('src', iconsSrcList[i]);
                    image.setAttribute('class', 'ecwid-PaymentMethodsBlockSvgCustom');
                    if (container.children.length !== 0) {
                        image.style.marginLeft = '5px';
                    }
                    container.appendChild(image);
                }
            }
        }
    }
};

/**
 * Function to process current payment in the list
 * @param label
 * @returns {Element | HTMLDivElement}
 */
var getPaymentContainer = function (label) {
    var container = label.parentNode.getElementsByClassName('payment-methods');
    if (container.length === 0) {
        container = [document.createElement('div')];
        container[0].className += 'payment-methods';
        container[0].style.paddingLeft = '18px';
        label.parentNode.appendChild(container[0]);
    }
    return container[0];
};




